import { NewsQuestionsFormView } from './news-questions-form-view'
import { NewsComment } from 'es6/models/news-comment'
import $ from 'init/jquery'
import { Defaults } from 'es-decorators'

@Defaults({
  MAX_COMMENT_LENGTH: 2000,
})
export class NewsCommentsFormView extends NewsQuestionsFormView {
  /**
   *@inheritDoc
   */
  _initModel () {
    this.model = new NewsComment({
      news_id: this.itemId,
      is_anonymously: false,
      message: '',
    })
  }

  /**
   * Отправка вопроса/ответа.
   * @param {Event} e
   */
  postQuestion (e) {
    e.preventDefault()
    this.model.save({ comment_status_id: 1 })
  }

  /**
   * Рендерим количество символов в новом комментарии
   * @param {Event} e
   */
  renderCounter (e) {
    let value = $(e.currentTarget).val(),
      length = value.length,
      MAX_COMMENT_LENGTH = 2000,
      counter = this.$('.char-counter'),
      diff = MAX_COMMENT_LENGTH - length
    if (length > MAX_COMMENT_LENGTH) {
      counter.addClass('error')
      counter.text(diff)
    } else {
      counter.removeClass('error')
      counter.text('')
    }
  }
}
